export class PromisedTimeout {
    static TIMEOUT: string = 'TimedPromise_timeout';
    static EARLY: string = 'TimedPromise_early';
    static CANCELLED: string = 'TimedPromise_cancel';

    // noinspection TypeScriptFieldCanBeMadeReadonly
    private _promise: Promise<any>;
    // noinspection TypeScriptFieldCanBeMadeReadonly
    private _resolveFunc: Function;
    // noinspection TypeScriptFieldCanBeMadeReadonly
    private _rejectFunc: Function;
    // noinspection TypeScriptFieldCanBeMadeReadonly
    private _timeoutId;

    /**
     * TODO: Make the timeout reject instead of resolve.
     * @param ms
     * @param timeoutResolveValue Handy if you need to conform to an interface
     */
    constructor(ms, timeoutResolveValue: any = PromisedTimeout.TIMEOUT) {
        this._promise = new Promise((resolve, reject) => {
            this._resolveFunc = resolve;
            this._rejectFunc = reject;
            this._timeoutId = setTimeout(() => {
                resolve(timeoutResolveValue);
            }, ms);
        });
    }

    triggerEarly() {
        clearTimeout(this._timeoutId);
        this._resolveFunc(PromisedTimeout.EARLY);
    }

    cancel() {
        clearTimeout(this._timeoutId);
        // Always reject with an error object so bluebird doesn't complain
        this._rejectFunc(new Error(PromisedTimeout.CANCELLED));
    }

    get promise(): Promise<any> {
        return this._promise;
    }
}
